import { GRAPH_DASHBOARD_QUERIES, GRAPHQL_DASHBOARD_MUTATIONS } from 'graphql/dashboard'
import type {
  DashboardMutationsName,
  DashboardQueriesName,
  DashboardsQueriesData,
  DashboardsQueriesVariables,
  TDashboardMutationsData,
  TDashboardMutationsVariables,
} from 'graphql/dashboard/types'
import { buildMutationHook, buildQueryHook } from 'lib/apollo-client/builders'

export const useDashboardsQueries = buildQueryHook<
  DashboardQueriesName,
  DashboardsQueriesVariables,
  DashboardsQueriesData
>(GRAPH_DASHBOARD_QUERIES)

export const useDashboardMutations = buildMutationHook<
  DashboardMutationsName,
  TDashboardMutationsVariables,
  TDashboardMutationsData
>(GRAPHQL_DASHBOARD_MUTATIONS)
